import AppointmentDetailHeader from './../AppointmentDetailHeader';
import AppointmentDetailBreadcrumb from './../AppointmentDetailBreadcrumb';
import AppointmentDetailContent from './../AppointmentDetailContent';

import {mapActions} from 'vuex';

import * as APPOINTMENT from '@/store/constants/appointment';

export default {
  name: 'AppointmentDetail',
  data() {
    return {
      appointment: {}
    }
  },
  components: {
    AppointmentDetailBreadcrumb,
    AppointmentDetailHeader,
    AppointmentDetailContent
  },

  computed: {},

  methods: {
    ...mapActions({
      getAppointment: APPOINTMENT.ACTION_GET_APPOINTMENT
    }),

    backToList() {
      this.$router.push({name: 'AppointmentList'});
    },

    /**
     *  Handle get appointment.
     *
     * @param id
     */
    handleGetAppointment(id) {
      this.getAppointment(id).then(res => {
        this.appointment = res.data;
      });
    },
  },

  created() {
    if (this.$route.params['appointment']) {
      this.appointment = this.$route.params['appointment'];
    } else {
      const appointmentId = this.$route.params['id'] || null;

      // Query the detail from the patient.
      if (!appointmentId) {
        this.backToList();
      }

      this.handleGetAppointment(appointmentId);
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Appointment/Detail/js/appointment-detail.js